/*
 * (C) Behaviour Interactive Inc. - All Rights Reserved
 * Unauthorized copying of this file, via any medium, is strictly prohibited
 * This file is proprietary and confidential
 */

import { v4 as uuidv4 } from 'uuid';
import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

import { STORAGE_KEYS } from './../../constants';
import { AnalyticsActions, AnalyticsStates } from './analytics.models';

const initialState: AnalyticsStates = {
  sessionExpiration: 0,
  sessionId: null,
  sessionOrder: 0,
  userConsent: false,
  sessionInfoSent: false,
};

export const useAnalyticsStore = create<AnalyticsActions & AnalyticsStates>()(
  persist(
    (set) => ({
      ...initialState,
      incrementSessionOrder() {
        set((state) => ({
          sessionOrder: state.sessionOrder + 1,
        }));
      },
      initSession: () => {
        set(() => ({
          sessionExpiration: Date.now() + 15 * 60 * 1000, // 15 minutes from now
          sessionId: uuidv4(),
          sessionOrder: 0,
        }));
      },
      resetSession: () => {
        set(initialState);
      },
      resetExpiration: () => {
        set(() => ({
          sessionExpiration: Date.now() + 15 * 60 * 1000, // 15 minutes from now
        }));
      },
      setUserConsent: (userConsent: boolean) => {
        set(() => ({
          userConsent,
        }));
      },
    }),
    {
      name: STORAGE_KEYS['ANALYTICS_SESSION_STORE'],
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
);
